export default __webpack_public_path__ + "static/media/higher_primary_logo.926eaef3.svg";